<div class="modal inmodal fade in show company-modal">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">New Management Company</h4>

                        <div class="input-group-btn pull-right">
                            <button class="btn btn-primary submit"
                                    type="submit" [disabled]="disabledSubmit">Save</button>

                            <button
                                data-toggle="dropdown"
                                class="btn btn-primary dropdown-toggle"
                                type="button"
                                aria-expanded="false">
                                <span class="caret"></span>
                            </button>

                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="close()">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="name" class="theme-name-label">Company Name</label>
                        </div>

                        <div class="col-md-8">
                            <input id="name" class="form-control" name="name" ngModel maxlength="255" required/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="email" class="theme-name-label">Email</label>
                        </div>

                        <div class="col-md-8">
                            <input id="email" class="form-control" name="email" ngModel maxlength="255" required/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="address" class="theme-name-label">Address</label>
                        </div>

                        <div class="col-md-8">
                            <input id="address" class="form-control" name="address" ngModel maxlength="255" required/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="phone" class="theme-name-label">Phone</label>
                        </div>

                        <div class="col-md-8">
                            <input id="phone" class="form-control" name="phone" ngModel maxlength="255"/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="primaryContact" class="theme-name-label">Primary Contact</label>
                        </div>

                        <div class="col-md-8">
                            <input id="primaryContact" class="form-control" name="primaryContact" ngModel maxlength="255"/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label for="loginpage" class="theme-name-label">Login Page</label>
                        </div>

                        <div class="col-md-8">
                            <input id="loginpage" class="form-control" name="loginpage" ngModel maxlength="255"/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label class="theme-name-label">Theme</label>
                        </div>

                        <div class="col-md-8">
                            <select class="form-control" name="theme" [ngModel]="theme">
                                <option value="" hidden></option>
                                <option *ngFor="let item of themesList" [value]="item.id">
                                    {{item.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal-backdrop fade in" (click)="close()"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-modal/company-modal.component.html